import React, { useEffect, useState } from "react";
import { wa } from "../mock";

export default function FloatingWhatsApp() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const target = document.getElementById("contact");
    if (!target || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      ([entry]) => setHidden(entry.isIntersecting),
      { threshold: 0.12 }
    );
    io.observe(target);
    return () => io.disconnect();
  }, []);

  return (
    <a href={wa()}
       target="_blank" rel="noopener noreferrer" aria-label="WhatsApp Kapatia" data-testid="whatsapp-float"
       className={`fixed bottom-4 right-4 z-40 animate-float-slow transition-all duration-300 sm:bottom-5 sm:right-5 ${hidden ? "pointer-events-none translate-y-8 opacity-0" : "opacity-100"}`}>
      <img src="/assets/icons/whatsapp-clean-square.png" alt="" className="h-11 w-11 rounded-full object-contain sm:h-14 sm:w-14"
           style={{ filter: "drop-shadow(0 12px 18px rgba(37,211,102,0.28)) drop-shadow(0 6px 12px rgba(45,106,79,0.16))" }} />
    </a>
  );
}
